<template>
  <div>
    <div class="row mx-0 brands-container py-2 mb-3">
      <div
        v-if="brands?.length > 1" class="align-items-center brand-type-container justify-content-center col px-5"
      >
        <div class="">
          <VSlickCarousel
            v-if="brands?.length"
            ref="slick"
            v-bind="brandSlick"
          >
            <template #prevArrow="arrowSlotProps">
              <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-left-arrow left-arrow-position"></em>
            </template>
            <template #nextArrow="arrowSlotProps">
              <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-right-arrow right-arrow-position"></em>
            </template>

            <div v-for="(brand, index) in brands" :key="index" class="text-center">
              <img
                @click="selectBrand(brand)"
                :key="index"
                :src="`https://prod.cdn.secureoffersites.com/images/menuinventory/${brand.toLowerCase().replace(' ', '_')}.png`"
                alt="Brand"
                class="brand-image img-fluid mx-auto"
                :class="{ active: selectedBrands.includes(brand) }"
              />
            </div>
          </VSlickCarousel>
        </div>
      </div>
      <div v-if="brands?.length > 1" class="separator-line mx-2">&nbsp;</div>

      <div class="col align-items-center brand-type-container px-5">
        <div class="brand-type-images-container">
          <VSlickCarousel v-if="vehicleTypes?.length" ref="slick2" v-bind="vehicleTypeSlick">
            <template #prevArrow="arrowSlotProps">
              <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-left-arrow left-arrow-position"></em>
            </template>
            <template #nextArrow="arrowSlotProps">
              <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-right-arrow right-arrow-position"></em>
            </template>
            <div v-for="(type, index) in vehicleTypes" :key="index">
              <div
                @click="selectType(type)"
                :key="index"
                class="brand-type cursor-pointer text-center"
                :class="{
                  active: selectedTypes.includes(type),
                  disabled: !availableTypes.includes(type),
                }"
                :disabled="!availableTypes.includes(type)"
              >
                {{ type }}
              </div>
            </div>
          </VSlickCarousel>
        </div>
      </div>
    </div>
    <div class="menu-inventory">
      <div
        v-if="filteredVehicles.length"
        class="container"
      >
        <div class="row model-items-container h-100">
          <div
            v-for="(model, index) in filteredVehicles"
            :key="index"
            class="model-item-block cursor-pointer"
            :class="vehicleGridLayout"
            @click="modelClick(model.vehicles)"
          >
            <div class="model-item-content p-4">
              <div
                v-if="model.vehicles.model"
                class="model-item-name mb-2 text-center font-weight-bold _theme_font_bold"
              >
                <p class="mb-0">{{ model.vehicles.year }} {{ model.vehicles.make }}</p>
                <p class="mb-0">{{ model.vehicles.model }}</p>
              </div>
              <div
                v-if="model.count"
                class="model-stock-count ft-12 text-center"
              >
                {{ model.count }} available
              </div>
              <div class="text-center model-img-block">
                <img
                  :src="frameUrl(model.vehicles, 95)"
                  :src-placeholder="frameUrl(model.vehicles, 6)"
                  class="img-fluid"
                  :alt="getAltValue(model)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center py-4">
        <strong>No vehicles available for the selected filters. Please adjust your selection.</strong>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "v-slick-carousel/style.css";
import { VSlickCarousel } from "v-slick-carousel";

export default {
  components: {
    VSlickCarousel
  },
  props: {
    setLoading: {
      type: Function,
      required: false,
      default: () => (status) => console.log(status),
    },
  },
  data() {
    return {
      isGhostMenu: window.menuStyleId === '15',
      vehicleGridLayout: "col-6 col-xl-4 col-xxl-3",
      vehicleTypes: [],
      brands: [],
      inventoryVehicles: [],
      selectedBrands: [],
      selectedTypes: [],
      useOverrides: window.digiServiceUseOverrides,
      brandSlick: {
        groupsToShow: 7,
        groupsToScroll: 1,
        infinite: false,
        arrows: true,
        "responsive": [
          {
            "breakpoint": 480,
            "settings": {
              "groupsToShow": this.isGhostMenu ? 3 : 4
            }
          },
          {
            "breakpoint": 1080,
            "settings": {
              "groupsToShow": this.isGhostMenu ? 3 : 5
            }
          },
          {
            "breakpoint": 1400,
            "settings": {
              "groupsToShow": this.isGhostMenu ? 4 : 6
            }
          },
          {
            "breakpoint": 1680,
            "settings": {
              "groupsToShow": this.isGhostMenu ? 5 : 7
            }
          }
        ]
      },
      vehicleTypeSlick: {
        groupsToShow: this.isGhostMenu ? 4 : 5,
        groupsToScroll: 1,
        infinite: false,
        arrows: true,
        "responsive": [
          {
            "breakpoint": 480,
            "settings": {
              "groupsToShow": 2
            }
          },
          {
            "breakpoint": 768,
            "settings": {
              "groupsToShow": this.isGhostMenu ? 2 : 3
            }
          },
          {
            "breakpoint": 1400,
            "settings": {
              "groupsToShow": this.isGhostMenu ? 3 : 4
            }
          },
          {
            "breakpoint": 1680,
            "settings": {
              "groupsToShow": this.isGhostMenu ? 4 : 5
            }
          }
        ]
      },

    };
  },
  async mounted() {
    await this.getVehicles();
    await this.getBrandsAndTypes();
    if(this.isGhostMenu) {
      this.vehicleGridLayout = "ol-6 col-xl-4";
    }
  },
  computed: {
    filteredVehicles() {
      return this.inventoryVehicles.filter(entry => {
        const vehicle = entry.vehicles;
        const brandMatch =
          this.selectedBrands.length === 0 || this.selectedBrands.includes(vehicle.make);
        const typeMatch =
          this.selectedTypes.length === 0 || this.selectedTypes.includes(vehicle.vehicleType);
        return brandMatch && typeMatch;
      });
    },
    availableTypes() {
      const typesSet = new Set();

      this.inventoryVehicles.forEach(entry => {
        const vehicle = entry.vehicles;
        const brandMatch =
          this.selectedBrands.length === 0 || this.selectedBrands.includes(vehicle.make);

        if (brandMatch && vehicle.vehicleType) {
          typesSet.add(vehicle.vehicleType);
        }
      });

      return Array.from(typesSet);
    }
  },
  methods: {
    getVehicles() {
      let inventorySortBy = 'pricehtol';

      let urlString = `${
        window.ApiBaseUrl
      }/Inventory/newmodelsBanners?accountId=${window.accountId}&campaignid=${window.campaignid}&themeName=${window.themeName.toLowerCase()}&sRPSortType=${inventorySortBy}&enableCountsOnInventoryControl=${
        window.enableCountsOnInventoryControl
      }&type=new&primaryInventoryVehiclesGroupbyModel=true`;

      let parameters = new URLSearchParams(window.location.search);
      if (parameters.has("fetchdatafrom")) {
        let queryparamvalue = parameters.get("fetchdatafrom");
        urlString = urlString + "&fetchdatafrom=" + queryparamvalue;
      }
      this.setLoading(true);
      axios
        .get(urlString)
        .then((response) => {
          let responseData = [];

          for (const newModel of response.data?.newModels || []) {
            if (newModel.vehicles) {
              responseData.push(newModel);
            }
          }

          this.inventoryVehicles = responseData;
          this.filteredVehicles = responseData;
        })
        .catch((err) => {
          console.error("Error fetching vehicle data:", err);
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    getBrandsAndTypes() {
      axios
        .get(
          `${
            window.ApiBaseUrl
          }/DealerGroup/GetDealerBrandsandTypesByType?campaignid=${window.campaignid}&accountId=${window.accountId}&&type=new`
        )
        .then((response) => {
          const { brands, types } = response.data;
          this.brands = brands;
          this.vehicleTypes = types;
        });
    },
    selectBrand(brand) {
      if (this.selectedBrands.includes(brand)) {
        // Deselect the brand
        this.selectedBrands = this.selectedBrands.filter(b => b !== brand);

        // Recalculate allowed types from remaining selected brands
        const remainingTypes = this.getVehicleTypesForBrands(this.selectedBrands);

        // Remove any selectedTypes that no longer exist in remaining types
        this.selectedTypes = this.selectedTypes.filter(type => remainingTypes.includes(type));
      } else {
        // Select the brand
        this.selectedBrands.push(brand);

        // Auto-select type if only one type exists for this brand
        const brandVehicleTypes = this.getVehicleTypesForBrand(brand);
        if (brandVehicleTypes.length === 1) {
          const onlyType = brandVehicleTypes[0];
          if (!this.selectedTypes.includes(onlyType)) {
            this.selectedTypes.push(onlyType);
          }
        }
      }

      this.ensureVehiclesVisible();
    },
    getVehicleTypesForBrands(brands) {
      const typesSet = new Set();

      this.inventoryVehicles.forEach(entry => {
        const vehicle = entry.vehicles;
        if (brands.includes(vehicle.make) && vehicle.vehicleType) {
          typesSet.add(vehicle.vehicleType);
        }
      });

      return Array.from(typesSet);
    },
    selectType(type) {
      if (this.selectedTypes.includes(type)) {
        this.selectedTypes = this.selectedTypes.filter(t => t !== type);
      } else {
        this.selectedTypes.push(type);
      }

      this.ensureVehiclesVisible();
    },
    ensureVehiclesVisible() {
      if (this.filteredVehicles.length === 0) {
        this.selectedBrands = [];
        this.selectedTypes = [];
      }
    },

    modelClick(vehicle) {
      if (!vehicle?.url) {
        console.warn("Vehicle URL is not available.");
        return;
      }

      const url = vehicle.url.includes("?")
        ? `${vehicle.url}&sorttype=pricehtol`
        : `${vehicle.url}?sorttype=pricehtol`;
        return window.open(url, "_self");
    },
    getAltValue(model) {
      if (!model) return "";
      return `${model.year} ${model.make} ${model.model}`;
    },
    frameUrl(vehicle, quality) {
      let imgSrc = vehicle?.photoURLs;
      if (!imgSrc) return "";
      const baseUrl = `${imgSrc}&autocrop=true&angle=01&quality=${quality}&width=300&colorcode=${vehicle.extColorCode}&vehicletype=${vehicle.vehicleType}`;
      if (!imgSrc.includes("service.secureoffersites.com")) {
        return imgSrc;
      }
      return this.useOverrides
        ? `${baseUrl}&useoverrides=${this.useOverrides}`
        : baseUrl;
    },
  },
};
</script>

<style scoped>
.menu-inventory {
  border-radius: 25px;
  background-color: #f3f3f3;
  overflow: scroll;
  padding: 30px 0px;
  max-height: 75vh;
  min-height: 75vh;
}
.model-item-content {
  max-width: 250px;
  margin: 0 auto;
  border-bottom: 1px solid #ddd;
  transition: transform 0.3s ease, opacity 0.3s ease, visibility 0s;
  position: relative;
  overflow: hidden;
}
.model-item-content:hover {
  background-color: #fff;
  transition: transform 0.3s ease, background-color 0.3s ease;
}
.model-item-content:hover .model-item-name{
  transform: translateY(0%);
}
.model-stock-count {
  text-align: center;
  opacity: 0;
  transform: translateY(20%);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.model-item-content:hover .model-stock-count {
  opacity: 1;
  transform: translateY(0%);
}
.model-item-name {
  font-size: 14px;
   transform: translateY(30%);
  transition: transform 0.3s ease;
}
.model-img-block {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.model-img-block img {
  max-height: 70px;
}

.brand-type-container {
  gap: 15px;
  white-space: nowrap;
  overflow: hidden;
}
.brand-type-images-container {
  white-space: nowrap;
  overflow: visible;
  max-width: 95%;
}
.left-arrow-position {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-20px, -50%);
}
.right-arrow-position {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(20px, -50%);
}
.separator-line {
  background-color: #ddd;
  width: 1px;
  height: 60px;
}

.brand-type-container .brand-type {
  font-size: 12px;
  margin: 0px 10px;
  max-height: 80px;
  padding: 10px 20px;
  border: 1px solid #ddd;
  border-radius: 25px;
  min-width: 100px;
}

.brands-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    cursor: pointer;
}
.model-items-container {
  margin-bottom: 200px;
}
.brand-image {
  font-size: 12px;
  margin: 0;
  display: block;
  border-radius: 50%;
  max-height: 60px;
}
.brand-image.active {
  border: 2px solid #333;
}

.brand-type.active {
  border: 2px solid #333;
  background-color: #e6f7ff;
  color: #333;
}

.brand-type.disabled {
  opacity: 0.5;
  pointer-events: none;
  background-color: #f5f5f5;
  color: #ccc;
}

.brands-container ::-webkit-scrollbar {
  height: 5px; /* height of horizontal scrollbar ← You're missing this */
  width: 5px; /* width of vertical scrollbar */
  border: 1px solid #d5d5d5;
}
</style>
